import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// A session killed server-side (password changed, account deactivated) should
// land the user on the sign-in screen with the reason, not a silent failure.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const detail = err.response?.data?.detail || "";
    const onLogin = window.location.pathname.startsWith("/login");
    if (status === 401 && !onLogin && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      const reason = /password change|deactivated|expired/i.test(detail) ? detail : "Your session has ended. Please sign in again.";
      window.location.replace(`/login?reason=${encodeURIComponent(reason)}`);
    }
    return Promise.reject(err);
  }
);

export default api;
